// src/pages/user/SettingsMain.js
import React, { useState } from "react";
import DynamicBackButton from "../../../components/backbutton/BackButton";
import MainHeader from "../../../components/header/MainHeader";
import Profile from "../../../pages/profile/Profile";
import SalesProfile from "../../salesprofile/SalesProfile";
import MySettings from "../../../pages/calculators/settings/SettingsPage";
import MyAdmin from "../../../pages/calculators/settings/MyAdmin";
//import { ThemeContext } from "../../../context/ThemeContext";
import "./settings.css";

export default function SettingsMain() {
  const [activeTab, setActiveTab] = useState("settings");

  let user = JSON.parse(localStorage.getItem("user") || "{}");

  return (
    <div className="calculater-layout application-fe settings-page">
      {/* Header */}
      <div className="calculator-header">
        <MainHeader />
      </div>

      <div className="calc-container backontop">
        <DynamicBackButton />

        {/* Tab Navigation */}
        <div className="settings-tabs-wrapper">
          <ul className="settings-tabs">
            {(user.user_type === "N" || user.user_type === "M") &&
              <li
                className={`tab-item ${activeTab === "profile" ? "active" : ""}`}
                onClick={() => setActiveTab("profile")}
              >
                My Profile
              </li>
            }
            {(user.user_type === "S" || user.user_type === "SM") &&
              <li
                className={`tab-item ${activeTab === "salesProfile" ? "active" : ""}`}
                onClick={() => setActiveTab("salesProfile")}
              >
                My Profile
              </li>
            }

            <li
              className={`tab-item ${activeTab === "settings" ? "active" : ""}`}
              onClick={() => setActiveTab("settings")}
            >
              My Settings
            </li>

            {(user.user_type === "S" || user.user_type === "SM") &&
              <li
                className={`tab-item ${activeTab === "admin" ? "active" : ""}`}
                onClick={() => setActiveTab("admin")}
              >
                My Admin
              </li>
            }
          </ul>
        </div>

        {/* Tab Content */}
        <div className="tab-content fade-in mt-8 profile-mysetting">
          {activeTab === "profile" && <Profile />}
          {activeTab === "salesProfile" && <SalesProfile />}
          {activeTab === "settings" && <MySettings />}
          {activeTab === "admin" /* && user.user_type === "S" */ && <MyAdmin />}
        </div>
      </div>
    </div>
  );
}
